<ng-container *ngIf="active">
  <ng-content></ng-content>
</ng-container>
